import React, { useEffect, useState, useContext } from 'react';
import { Grid, FormLabel, FormHelperText, CircularProgress, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { SecondaryButton, TextBox, YesNoButton, SingelSelect, SelectBox } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getTCardUserHolidayType, postTCardUserHolidayType } from '../../../../Core/Service/t-card-holidayType-service';
import { SketchPicker } from 'react-color';

const AddUpdateHolidayTypeModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        tCardUserHolidayTypeDescription: '',
        tCardUserHolidayTypeTextColour: '#000000',
        tCardUserHolidayTypeBackColour: '#ffffff',
        errors: {}
    });

    useEffect(() => {
        const fetchHolidayType = async () => {
            if (props.holidayTypeID) {
                setLoading(true);
                try {
                    let res = await getTCardUserHolidayType(props.holidayTypeID);
                    let data = res?.data?.list?.table[0] || {};
                    if (res.success) {
                        setState((st) => ({
                            ...st,
                            tCardUserHolidayTypeDescription: data.tCardUserHolidayTypeDescription,

                            tCardUserHolidayTypeTextColour: data.tCardUserHolidayTypeTextColour || '#000000',
                            tCardUserHolidayTypeBackColour: data.tCardUserHolidayTypeBackColour || '#ffffff'
                        }));
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchHolidayType();
    }, [props.holidayTypeID]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.tCardUserHolidayTypeDescription.trim()) {
            formIsValid = false;
            errors.tCardUserHolidayTypeDescription = 'Description is required.';
        }

        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            try {
                const data = {
                    tCardUserHolidayTypeID: props.holidayTypeID || null,
                    tCardUserHolidayTypeDescription: state.tCardUserHolidayTypeDescription,
                    tCardUserHolidayTypeTextColour: state.tCardUserHolidayTypeTextColour,
                    tCardUserHolidayTypeBackColour: state.tCardUserHolidayTypeBackColour
                };
                console.log(data, 'opp');
                let res = await postTCardUserHolidayType(data);
                if (res.data.success) {
                    showToast(`Holiday Type ${props.holidayTypeID ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div>
            {loading ? (
                <div style={{ margin: '325px 270px' }}>
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold' }}>Loading...</Typography>
                </div>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormLabel className="mandatoryfields">Description*</FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardUserHolidayTypeDescription} name="tCardUserHolidayTypeDescription" />
                        {state.errors.tCardUserHolidayTypeDescription && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardUserHolidayTypeDescription}</FormHelperText>
                        )}
                    </Grid>

                    <Grid container spacing={2} style={{ marginLeft: -10, marginRight: 10 }}>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'center', padding: 20 }}>
                            <FormLabel style={{ textAlign: 'center', padding: 10 }}>
                                <b>Text Colour</b>
                            </FormLabel>
                            <SketchPicker
                                color={state.tCardUserHolidayTypeTextColour}
                                onChange={(color) => setState((st) => ({ ...st, tCardUserHolidayTypeTextColour: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'center', padding: 20 }}>
                            <FormLabel style={{ textAlign: 'center', padding: 10 }}>
                                <b>Background Colour</b>
                            </FormLabel>
                            <SketchPicker
                                color={state.tCardUserHolidayTypeBackColour}
                                onChange={(color) => setState((st) => ({ ...st, tCardUserHolidayTypeBackColour: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default AddUpdateHolidayTypeModal;
